<template>
  <div class="cpt-detail">
    <div class="close" @click="close()">
      <img src="../assets/images/close.png" />
    </div>
    <div class="label">奖品信息</div>
    <div class="content">
      <div class="text">
        <div v-html="detailText"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail',
  props: ['detailText'],
  data() {
    return {};
  },
  components: {},
  methods: {
    close() {
      this.$emit('closeDetail');
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.cpt-detail {
  position: relative;
  padding-top: 12px;
  .label {
    margin: 0 0 12px 12px;
    font-weight: 500;
    font-size: 16px;
    color: #14191e;
  }
  .content {
    height: 50vh;
    padding: 0 12px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .text {
      font-size: 15px;
      line-height: 21px;
      color: #000000;
    }
  }
  .close {
    position: absolute;
    top: 11px;
    right: 12px;
    width: 24px;
    height: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
